import PropTypes from "prop-types"
import "./chevron.scss"

export default function Chevron({ width, height, color, direction }) {
  return (
    <svg
      width={width}
      height={height}
      styleName={direction}
      viewBox="0 0 16 11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M8 10.4l8-8L13.6 0 8 5.6 2.4 0 0 2.4l8 8z"
        fillRule="evenodd"
      />
    </svg>
  )
}

Chevron.defaultProps = {
  width: 17,
  height: 9,
  color: "white",
  direction: "up",
}

Chevron.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  rotation: PropTypes.oneOf(["up", "down"]),
}
